import { PIXEL_SIZE } from './shared'
import { num } from './utils'
import { EQUIP_SLOTS, INVENTORY_SIZE } from './inventories'

export const entities = {
  ironVein: {
    name: 'ironVein',
    type: 'harvest_node',
    label: 'Iron Vein',
    icon: '/assets/vein.iron.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'ironVein',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
          yBase: 5 * PIXEL_SIZE,
          yCenter: 0 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/vein.iron.png',
        },
        shadow: {
          url: '/assets/vein.shadow.png',
        },
        collider: {
          ox: -7 * PIXEL_SIZE,
          oy: 0 * PIXEL_SIZE,
          w: 15 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        harvest: {
          wobble: true,
          melee: { tool: 'pickaxe', tier: 1 },
          sound: { name: 'pickaxe-on-rock', pitch: 0.2 },
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'ironOre', qty: [1, 1], weight: 30 },
                { id: null, weight: 70 },
              ],
            },
          ],
          depletedChance: 30,
          depletedSprite: '/assets/vein.png',
          depletedShadow: '/assets/vein.shadow.png',
          respawn: [30, 60],
        },
        target: {
          oy: 5 * PIXEL_SIZE,
          radius: 7 * PIXEL_SIZE,
        },
      }
    },
  },
  tree: {
    name: 'tree',
    type: 'harvest_node',
    label: 'Tree',
    icon: '/assets/tree.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'tree',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
          yBase: 5 * PIXEL_SIZE,
          yCenter: 5 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/tree.png',
          width: 2,
          height: 3,
        },
        shadow: {
          url: '/assets/tree.shadow.png',
          width: 2,
          height: 3,
        },
        collider: {
          ox: -3 * PIXEL_SIZE,
          oy: 4 * PIXEL_SIZE,
          w: 6 * PIXEL_SIZE,
          h: 4 * PIXEL_SIZE,
        },
        harvest: {
          wobble: true,
          melee: { tool: 'axe', tier: 1 },
          sound: { name: 'wood-chop', pitch: 0.2 },
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'log', qty: [1, 1], weight: 30 },
                { id: null, weight: 70 },
              ],
            },
          ],
          depletedChance: 20,
          depletedSprite: '/assets/tree.stump.png',
          depletedShadow: '/assets/tree.stump.shadow.png',
          respawn: [30, 60],
        },
        target: {
          oy: 5 * PIXEL_SIZE,
          radius: 3 * PIXEL_SIZE,
        },
      }
    },
  },
  berryBush: {
    name: 'berryBush',
    type: 'harvest_node',
    label: 'Berry Bush',
    icon: '/assets/bush.berries.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'berryBush',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
          yBase: 2 * PIXEL_SIZE,
          // yCenter: 2 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/bush.berries.png',
          width: 1,
          height: 1,
        },
        shadow: {
          url: '/assets/bush.shadow.png',
        },
        // collider: {
        //   ox: -3 * PIXEL_SIZE,
        //   oy: 4 * PIXEL_SIZE,
        //   w: 6 * PIXEL_SIZE,
        //   h: 4 * PIXEL_SIZE,
        // },
        harvest: {
          wobble: false,
          melee: {},
          sound: { name: 'bush-forage', pitch: 0.05, volume: 0.5 },
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'strawberry', qty: [1, 3], weight: 100 },
                // { id: null, weight: 70 },
              ],
            },
          ],
          depletedChance: 100,
          depletedSprite: '/assets/bush.png',
          depletedShadow: '/assets/bush.shadow.png',
          respawn: [3, 5], // [60 * 5, 60 * 30],
        },
        target: {
          oy: 4 * PIXEL_SIZE,
          radius: 6 * PIXEL_SIZE,
        },
      }
    },
  },
  cottonPlant: {
    name: 'cottonPlant',
    type: 'harvest_node',
    label: 'Cotton Plant',
    icon: '/assets/cotton-plant.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'cottonPlant',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
          yBase: 4 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/cotton-plant.png',
        },
        shadow: {
          url: '/assets/cotton-plant.shadow.png',
        },
        harvest: {
          wobble: true,
          melee: {},
          sound: { name: 'bush-forage', pitch: 0.05, volume: 0.5 },
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'cotton', qty: [1, 4], weight: 100 },
                // { id: null, weight: 70 },
              ],
            },
          ],
          depletedChance: 100,
          depletedSprite: '/assets/cotton-plant.depleted.png',
          depletedShadow: '/assets/cotton-plant.shadow.png',
          respawn: [10, 20],
        },
        target: {
          oy: 4 * PIXEL_SIZE,
          radius: 5 * PIXEL_SIZE,
        },
      }
    },
  },
  stick: {
    name: 'stick',
    type: 'harvest_node',
    label: 'Stick',
    icon: '/assets/stick.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'stick',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
        },
        sprite: {
          url: '/assets/stick.png',
          ySort: 1, // always below things, no y-sort
        },
        shadow: {
          url: '/assets/stick.shadow.png',
        },
        harvest: {
          wobble: false,
          sound: { name: 'bush-forage', pitch: 0.1, volume: 0.5 },
          loot: [
            {
              rolls: 1,
              entries: [{ id: 'stick', qty: [1, 1], weight: 100 }],
            },
          ],
          depletedChance: 100,
          depletedSprite: null,
          depletedShadow: null,
          respawn: [10, 10],
        },
        interact: {
          label: 'Pick up',
        },
        target: {
          oy: 6 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
      }
    },
  },
  stone: {
    name: 'stone',
    type: 'harvest_node',
    label: 'Stone',
    icon: '/assets/stone.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'stone',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
          yBase: 5 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/stone.png',
        },
        shadow: {
          url: '/assets/stone.shadow.png',
        },
        collider: {
          ox: -6 * PIXEL_SIZE,
          oy: 3 * PIXEL_SIZE,
          w: 11 * PIXEL_SIZE,
          h: 5 * PIXEL_SIZE,
        },
        harvest: {
          wobble: false,
          sound: { name: 'bush-forage', pitch: 0.1, volume: 0.5 },
          loot: [
            {
              rolls: 1,
              entries: [{ id: 'stone', qty: [1, 1], weight: 100 }],
            },
          ],
          depletedChance: 100,
          depletedSprite: null,
          depletedShadow: null,
          depletedCollider: null,
          respawn: [10, 10],
        },
        interact: {
          label: 'Pick up',
        },
        target: {
          oy: 5 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
      }
    },
  },
  fishPool: {
    name: 'fishPool',
    type: 'harvest_node',
    label: 'Fish Pool',
    icon: '/assets/fish-pool.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'fishPool',
        type: 'harvest_node',
        chunkId,
        position: {
          x,
          y,
        },
        sprite: {
          url: '/assets/fish-pool.png',
          width: 1,
          height: 1,
          fps: 2,
          ySort: 1, // always below things, no y-sort
        },
        harvest: {
          soundStart: { name: 'rod-cast', pitch: 0.1, volume: 0.6 },
          sound: { name: 'splash', pitch: 0.1, volume: 0.6 },
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'fishRaw', qty: [1, 1], weight: 80 },
                { id: null, weight: 20 },
              ],
            },
          ],
          depletedChance: 33,
          depletedSprite: null,
          depletedShadow: null,
          respawn: [30, 60],
        },
        interact: {
          label: 'Fish',
          tool: 'rod',
          tier: 1,
          duration: [3, 6],
          locomotion: 'fish',
        },
        target: {
          oy: 8 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
      }
    },
  },
  chest: {
    name: 'chest',
    type: 'container',
    label: 'Chest',
    icon: '/assets/chest.png',
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'chest',
        type: 'container',
        chunkId,
        position: {
          x,
          y,
          yBase: 4 * PIXEL_SIZE,
          // yCenter: 4 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/chest.png',
        },
        collider: {
          ox: -7 * PIXEL_SIZE,
          oy: 0 * PIXEL_SIZE,
          w: 14 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        interact: {
          label: 'Open',
        },
        target: {
          oy: 4 * PIXEL_SIZE,
          radius: 10 * PIXEL_SIZE,
        },
        container: {
          title: 'Chest',
          openSprite: { url: '/assets/chest-open.png' },
          closedSprite: { url: '/assets/chest.png' },
        },
        inventory: {
          type: 'container',
          slots: (() => {
            const slots = new Array(INVENTORY_SIZE).fill(null)
            // slots[0] = { id: 'ironSword', qty: 1 }
            // slots[1] = { id: 'ironAxe', qty: 1 }
            slots[2] = { id: 'apple', qty: 3 }
            slots[3] = { id: 'log', qty: 1 }
            return slots
          })(),
        },
      }
    },
  },
  campfire: {
    name: 'campfire',
    type: 'station',
    label: 'Campfire',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'campfire',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 4 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/campfire.png',
        },
        collider: {
          ox: -6 * PIXEL_SIZE,
          oy: 1 * PIXEL_SIZE,
          w: 13 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        interact: {
          label: 'Cook',
        },
        target: {
          oy: 5 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/campfire.shadow.png',
        },
        station: {
          title: 'Campfire',
        },
        recipes: [
          {
            id: 'fishCooked',
            output: { id: 'fishCooked', qty: 1 },
            input: [{ id: 'fishRaw', qty: 1 }],
          },
        ],
      }
    },
  },
  tanningRack: {
    name: 'tanningRack',
    type: 'station',
    label: 'Tanning Rack',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'tanningRack',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 9 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/tanning-rack.png',
          width: 2,
          height: 2,
        },
        collider: {
          ox: -8 * PIXEL_SIZE,
          oy: 6 * PIXEL_SIZE,
          w: 16 * PIXEL_SIZE,
          h: 5 * PIXEL_SIZE,
        },
        interact: {
          label: 'Tan',
        },
        target: {
          oy: 9 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/tanning-rack.shadow.png',
          width: 2,
          height: 2,
        },
        station: {
          title: 'Tanning Rack',
        },
        recipes: [
          {
            id: 'leather',
            output: { id: 'leather', qty: 1 },
            input: [{ id: 'hide', qty: 2 }],
          },
        ],
      }
    },
  },
  armory: {
    name: 'armory',
    type: 'station',
    label: 'Armory',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'armory',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 5 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/armory.png',
          width: 2,
          height: 2,
        },
        collider: {
          ox: -14 * PIXEL_SIZE,
          oy: 2 * PIXEL_SIZE,
          w: 28 * PIXEL_SIZE,
          h: 8 * PIXEL_SIZE,
        },
        interact: {
          label: 'Tan',
        },
        target: {
          oy: 8 * PIXEL_SIZE,
          radius: 16 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/armory.shadow.png',
          width: 2,
          height: 2,
        },
        station: {
          title: 'Armory',
        },
        recipes: [
          {
            id: 'clothHood',
            output: { id: 'clothHood', qty: 1 },
            input: [{ id: 'cotton', qty: 5 }],
          },
          {
            id: 'clothVest',
            output: { id: 'clothVest', qty: 1 },
            input: [{ id: 'cotton', qty: 4 }],
          },
          {
            id: 'clothLeggings',
            output: { id: 'clothLeggings', qty: 1 },
            input: [{ id: 'cotton', qty: 3 }],
          },
          {
            id: 'leatherCowl',
            output: { id: 'leatherCowl', qty: 1 },
            input: [{ id: 'leather', qty: 2 }],
          },
          {
            id: 'leatherTop',
            output: { id: 'leatherTop', qty: 1 },
            input: [{ id: 'leather', qty: 3 }],
          },
          {
            id: 'leatherPants',
            output: { id: 'leatherPants', qty: 1 },
            input: [{ id: 'leather', qty: 2 }],
          },
          {
            id: 'ironHelm',
            output: { id: 'ironHelm', qty: 1 },
            input: [{ id: 'ironBar', qty: 3 }],
          },
          {
            id: 'ironChestplate',
            output: { id: 'ironChestplate', qty: 1 },
            input: [{ id: 'ironBar', qty: 4 }],
          },
          {
            id: 'ironLeggings',
            output: { id: 'ironLeggings', qty: 1 },
            input: [{ id: 'ironBar', qty: 2 }],
          },
        ],
      }
    },
  },
  anvil: {
    name: 'anvil',
    type: 'station',
    label: 'Anvil',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'anvil',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 4 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/anvil.png',
        },
        collider: {
          ox: -8 * PIXEL_SIZE,
          oy: 2 * PIXEL_SIZE,
          w: 16 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        interact: {
          label: 'Craft',
        },
        target: {
          oy: 4 * PIXEL_SIZE,
          radius: 12 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/anvil.shadow.png',
        },
        station: {
          title: 'Anvil',
        },
        recipes: [
          {
            id: 'ironAxe',
            output: { id: 'ironAxe', qty: 1 },
            input: [{ id: 'ironBar', qty: 2 }],
          },
          {
            id: 'ironSword',
            output: { id: 'ironSword', qty: 1 },
            input: [{ id: 'ironBar', qty: 3 }],
          },
          {
            id: 'ironDagger',
            output: { id: 'ironDagger', qty: 1 },
            input: [{ id: 'ironBar', qty: 2 }],
          },
          {
            id: 'ironMaul',
            output: { id: 'ironMaul', qty: 1 },
            input: [{ id: 'ironBar', qty: 4 }],
          },
        ],
      }
    },
  },
  furnace: {
    name: 'furnace',
    type: 'station',
    label: 'Furnace',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'furnace',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 5 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/furnace.png',
          width: 1,
          height: 2,
        },
        shadow: {
          url: '/assets/furnace.shadow.png',
          width: 1,
          height: 2,
        },
        collider: {
          ox: -6 * PIXEL_SIZE,
          oy: 2 * PIXEL_SIZE,
          w: 12 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        interact: {
          label: 'Craft',
        },
        target: {
          oy: 5 * PIXEL_SIZE,
          radius: 5 * PIXEL_SIZE,
        },
        station: {
          title: 'Furnace',
        },
        recipes: [
          {
            id: 'ironBar',
            output: { id: 'ironBar', qty: 1 },
            input: [{ id: 'ironOre', qty: 2 }],
          },
        ],
      }
    },
  },
  workbench: {
    name: 'workbench',
    type: 'station',
    label: 'Workbench',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'workbench',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 4 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/workbench.png',
        },
        collider: {
          ox: -8 * PIXEL_SIZE,
          oy: 2 * PIXEL_SIZE,
          w: 16 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        interact: {
          label: 'Craft',
        },
        target: {
          oy: 4 * PIXEL_SIZE,
          radius: 12 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/workbench.shadow.png',
        },
        station: {
          title: 'Workbench',
        },
        recipes: [
          {
            id: 'woodSword',
            input: [{ id: 'stick', qty: 4 }],
            output: { id: 'woodSword', qty: 1 },
          },
          {
            id: 'woodAxe',
            input: [{ id: 'stick', qty: 4 }],
            output: { id: 'woodAxe', qty: 1 },
          },
          {
            id: 'woodPickaxe',
            input: [{ id: 'stick', qty: 4 }],
            output: { id: 'woodPickaxe', qty: 1 },
          },
          {
            id: 'slingshot',
            input: [
              { id: 'stick', qty: 4 },
              { id: 'stone', qty: 1 },
            ],
            output: { id: 'slingshot', qty: 1 },
          },
          {
            id: 'bow',
            input: [
              { id: 'log', qty: 4 },
              { id: 'stone', qty: 3 },
            ],
            output: { id: 'bow', qty: 1 },
          },
          {
            id: 'woodRod',
            input: [
              { id: 'stick', qty: 4 },
              { id: 'stone', qty: 1 },
            ],
            output: { id: 'woodRod', qty: 1 },
          },
        ],
      }
    },
  },
  altar: {
    name: 'altar',
    type: 'station',
    label: 'Altar',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'altar',
        type: 'station',
        chunkId,
        position: {
          x,
          y,
          yBase: 6 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/altar.png',
        },
        collider: {
          ox: -7 * PIXEL_SIZE,
          oy: 3 * PIXEL_SIZE,
          w: 14 * PIXEL_SIZE,
          h: 7 * PIXEL_SIZE,
        },
        interact: {
          label: 'Craft',
        },
        target: {
          oy: 7 * PIXEL_SIZE,
          radius: 8 * PIXEL_SIZE,
        },
        shadow: {
          url: '/assets/altar.shadow.png',
        },
        station: {
          title: 'Altar',
        },
        recipes: [
          {
            id: 'fireStaff',
            input: [{ id: 'stick', qty: 3 }],
            output: { id: 'fireStaff', qty: 1 },
          },
        ],
      }
    },
  },
  dude: {
    name: 'dude',
    type: 'character',
    label: 'Dude',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'dude',
        type: 'character',
        faction: 'dude',
        chunkId,
        spawn: {
          // todo: this should be the respawn position in death.respawnLocation = [x,y] yeah?
          x,
          y,
        },
        death: {
          respawn: [30, 40],
          decompose: 30,
          loot: [
            {
              rolls: 1,
              entries: [
                { id: 'apple', qty: [1, 2], weight: 40 },
                // { id: null, weight: 60 },
              ],
            },
          ],
        },
        position: {
          x,
          y,
          yBase: 15 * PIXEL_SIZE,
          yCenter: 21 * PIXEL_SIZE,
        },
        unit: {
          oy: 38 * PIXEL_SIZE,
          name: 'Dude',
        },
        combat: {
          health: 50,
          maxHealth: 50,
          energy: 100,
          dead: false,
        },
        stats: {
          defense: 0,
          crit: 0,
          speed: 0,
          energy: 0,
        },
        unarmed: {
          kind: 'melee',
          cooldown: 0.4,
          energy: 25,
          emote: 'slash',
          aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.1, farDist: 1.3, farWidth: 1.3 },
          immediate: { damage: [1, 3], maxTargets: 1 },
        },
        movement: {
          speed: 3,
        },
        ai: {
          aggro: 3,
          pursue: 3,
          leash: 3,
          social: 3,
        },
        inventory: {
          type: 'equipment',
          slots: (() => {
            const slots = new Array(INVENTORY_SIZE).fill(null)
            if (num(0, 100) > 50) {
              slots[EQUIP_SLOTS.rItem] = { id: 'woodSword', qty: 1 }
            } else if (num(0, 100) > 50) {
              slots[EQUIP_SLOTS.rItem] = { id: 'bow', qty: 1 }
            } else {
              slots[EQUIP_SLOTS.rItem] = { id: 'fireStaff', qty: 1 }
            }
            // slots[EQUIP_SLOTS.chest] = { id: 'blueHoodie', qty: 1 }
            return slots
          })(),
          held: 0,
        },
        avatar: {
          width: 3,
          height: 3,
          totalFrames: 61,
          animations: {
            idle: {
              south: { from: 0, to: 1, fps: 1 },
              north: { from: 2, to: 3, fps: 1 },
              east: { from: 4, to: 5, fps: 1 },
              west: { from: 6, to: 7, fps: 1 },
            },
            walk: {
              south: { from: 8, to: 13, fps: 8 },
              north: { from: 14, to: 19, fps: 8 },
              east: { from: 20, to: 22, fps: 8 },
              west: { from: 23, to: 25, fps: 8 },
            },
            slash: {
              south: { from: 26, to: 28, fps: 12 },
              north: { from: 29, to: 31, fps: 12 },
              east: { from: 32, to: 34, fps: 12 },
              west: { from: 35, to: 37, fps: 12 },
            },
            loose: {
              south: { from: 38, to: 40, fps: 8 },
              north: { from: 41, to: 43, fps: 8 },
              east: { from: 44, to: 46, fps: 8 },
              west: { from: 47, to: 49, fps: 8 },
            },
            fish: {
              south: { from: 50, to: 51, fps: 1 },
              north: { from: 52, to: 53, fps: 1 },
              east: { from: 54, to: 55, fps: 1 },
              west: { from: 56, to: 57, fps: 1 },
            },
            death: {
              all: { from: 58, to: 60, fps: 8, loop: false },
            },
          },
          baseLayers: {
            body: { url: '/assets/body.layer.png', tint: '#ffffff' },
            lHand: { url: '/assets/l-hand.layer.png', tint: '#ffffff' },
            rHand: { url: '/assets/r-hand.layer.png', tint: '#ffffff' },
          },
          layers: {},
          direction: 'south',
          locomotion: 'idle',
        },
        collider: {
          ox: -4 * PIXEL_SIZE,
          oy: 15 * PIXEL_SIZE,
          w: 8 * PIXEL_SIZE,
          h: 2 * PIXEL_SIZE,
        },
        target: {
          oy: 22 * PIXEL_SIZE,
          radius: 7 * PIXEL_SIZE,
        },
      }
    },
  },
  bunny: {
    name: 'bunny',
    type: 'character',
    label: 'Bunny',
    icon: null,
    create({ id, x, y, chunkId = null }) {
      return {
        id,
        name: 'bunny',
        type: 'character',
        faction: 'bunny',
        chunkId,
        spawn: {
          // todo: this should be the respawn position in death.respawnLocation = [x,y] yeah?
          x,
          y,
        },
        death: {
          respawn: [20, 30],
          decompose: 30,
          loot: [
            {
              rolls: 1,
              entries: [{ id: 'hide', qty: [1, 1], weight: 100 }],
            },
          ],
        },
        position: {
          x,
          y,
          yBase: 15 * PIXEL_SIZE,
          yCenter: 20 * PIXEL_SIZE,
        },
        unit: {
          oy: 24 * PIXEL_SIZE,
          name: 'Bunny',
        },
        combat: {
          health: 30,
          maxHealth: 30,
          energy: 100,
          dead: false,
        },
        stats: {
          defense: 0,
          crit: 0,
          speed: 0,
          energy: 0,
        },
        unarmed: {
          kind: 'melee',
          cooldown: 1,
          energy: 25,
          emote: 'slash',
          aim: { shape: 'trap', nearDist: 0.2, nearWidth: 0.8, farDist: 1.0, farWidth: 0.8 },
          immediate: { damage: [3, 6], maxTargets: 1 },
        },
        movement: {
          speed: 2,
        },
        ai: {
          pursue: 3,
          leash: 3,
          roam: { radius: 6, pause: [2, 6] },
        },
        inventory: {
          type: 'equipment',
          slots: (() => {
            const slots = new Array(INVENTORY_SIZE).fill(null)
            // if (num(0, 100) > 50) {
            //   slots[EQUIP_SLOTS.rItem] = { id: 'woodSword', qty: 1 }
            // } else if (num(0, 100) > 50) {
            //   slots[EQUIP_SLOTS.rItem] = { id: 'bow', qty: 1 }
            // } else {
            //   slots[EQUIP_SLOTS.rItem] = { id: 'fireStaff', qty: 1 }
            // }
            return slots
          })(),
          held: 0,
        },
        avatar: {
          width: 3,
          height: 3,
          totalFrames: 61,
          animations: {
            idle: {
              south: { from: 0, to: 1, fps: 1 },
              north: { from: 2, to: 3, fps: 1 },
              east: { from: 4, to: 5, fps: 1 },
              west: { from: 6, to: 7, fps: 1 },
            },
            walk: {
              south: { from: 8, to: 13, fps: 8 },
              north: { from: 14, to: 19, fps: 8 },
              east: { from: 20, to: 22, fps: 8 },
              west: { from: 23, to: 25, fps: 8 },
            },
            slash: {
              south: { from: 26, to: 28, fps: 12 },
              north: { from: 29, to: 31, fps: 12 },
              east: { from: 32, to: 34, fps: 12 },
              west: { from: 35, to: 37, fps: 12 },
            },
            loose: {
              south: { from: 38, to: 40, fps: 8 },
              north: { from: 41, to: 43, fps: 8 },
              east: { from: 44, to: 46, fps: 8 },
              west: { from: 47, to: 49, fps: 8 },
            },
            fish: {
              south: { from: 50, to: 51, fps: 1 },
              north: { from: 52, to: 53, fps: 1 },
              east: { from: 54, to: 55, fps: 1 },
              west: { from: 56, to: 57, fps: 1 },
            },
            death: {
              all: { from: 58, to: 60, fps: 8, loop: false },
            },
          },
          shadow: '/assets/bunny.shadow.png',
          baseLayers: {
            body: { url: '/assets/bunny.layer.png', tint: '#ffffff' },
          },
          layers: {},
          direction: 'south',
          locomotion: 'idle',
        },
        collider: {
          ox: -3 * PIXEL_SIZE,
          oy: 15 * PIXEL_SIZE,
          w: 6 * PIXEL_SIZE,
          h: 2 * PIXEL_SIZE,
        },
        target: {
          oy: 21 * PIXEL_SIZE,
          radius: 6 * PIXEL_SIZE,
        },
      }
    },
  },
  player: {
    name: 'player',
    type: 'character',
    label: 'Player',
    icon: null,
    serialize(data) {
      const dead = data.combat?.dead
      return {
        chunkId: null,
        spawn: data.spawn,
        position: dead ? { ...data.position, x: data.spawn.x, y: data.spawn.y } : data.position,
        inventory: data.inventory,
        health: dead ? data.combat.maxHealth : data.combat?.health,
        resonance: dead ? 100 : data.combat?.resonance,
        admin: data.admin,
      }
    },
    create({ id, x, y, chunkId }, saved) {
      const sx = saved?.position?.x ?? x
      const sy = saved?.position?.y ?? y
      return {
        id,
        name: 'player',
        type: 'character',
        chunkId,
        admin: saved?.admin || false,
        spawn: saved?.spawn ?? { x, y },
        position: {
          x: sx,
          y: sy,
          yBase: 15 * PIXEL_SIZE,
          yCenter: 21 * PIXEL_SIZE,
        },
        unit: {
          oy: 38 * PIXEL_SIZE,
          name: 'Anon',
        },
        combat: {
          health: saved?.health ?? 100,
          maxHealth: 100,
          energy: 100,
          resonance: saved?.resonance ?? 100,
          dead: false,
        },
        death: {
          respawn: [3, 3],
          decompose: 3,
        },
        movement: {
          speed: 4,
        },
        stats: {
          defense: 0,
          crit: 0,
          speed: 0,
          energy: 0,
        },
        unarmed: {
          kind: 'melee',
          cooldown: 0.4,
          energy: 25,
          emote: 'slash',
          aim: { shape: 'trap', nearDist: 0.2, nearWidth: 1.1, farDist: 1.3, farWidth: 1.3 },
          immediate: { damage: [1, 3], maxTargets: 1 },
        },
        avatar: {
          width: 3,
          height: 3,
          totalFrames: 61,
          animations: {
            idle: {
              south: { from: 0, to: 1, fps: 1 },
              north: { from: 2, to: 3, fps: 1 },
              east: { from: 4, to: 5, fps: 1 },
              west: { from: 6, to: 7, fps: 1 },
            },
            walk: {
              south: { from: 8, to: 13, fps: 8 },
              north: { from: 14, to: 19, fps: 8 },
              east: { from: 20, to: 22, fps: 8 },
              west: { from: 23, to: 25, fps: 8 },
            },
            slash: {
              south: { from: 26, to: 28, fps: 12 },
              north: { from: 29, to: 31, fps: 12 },
              east: { from: 32, to: 34, fps: 12 },
              west: { from: 35, to: 37, fps: 12 },
            },
            loose: {
              south: { from: 38, to: 40, fps: 8 },
              north: { from: 41, to: 43, fps: 8 },
              east: { from: 44, to: 46, fps: 8 },
              west: { from: 47, to: 49, fps: 8 },
            },
            fish: {
              south: { from: 50, to: 51, fps: 1 },
              north: { from: 52, to: 53, fps: 1 },
              east: { from: 54, to: 55, fps: 1 },
              west: { from: 56, to: 57, fps: 1 },
            },
            death: {
              all: { from: 58, to: 60, fps: 8, loop: false },
            },
          },
          baseLayers: {
            body: { url: '/assets/body.layer.png', tint: '#ffffff' },
            lHand: { url: '/assets/l-hand.layer.png', tint: '#ffffff' },
            rHand: { url: '/assets/r-hand.layer.png', tint: '#ffffff' },
          },
          layers: {},
          direction: 'south',
          locomotion: 'idle',
        },
        inventory: saved?.inventory ?? {
          type: 'equipment',
          slots: (() => {
            const slots = new Array(INVENTORY_SIZE).fill(null)
            // slots[EQUIP_SLOTS.rItem] = { id: 'sword', qty: 1 } // weapon slot
            // slots[0] = { id: 'apple', qty: 5 } // hotbar consumables
            // slots[1] = { id: 'strawberry', qty: 5 }
            // slots[6] = { id: 'bow', qty: 1 } // extra weapons in general inv
            // slots[7] = { id: 'axe', qty: 1 }
            // slots[8] = { id: 'fireStaff', qty: 1 }
            // slots[9] = { id: 'blueHoodie', qty: 1 }
            // slots[10] = { id: 'leatherPants', qty: 1 }
            // slots[11] = { id: 'leatherTop', qty: 1 }
            // slots[12] = { id: 'redCape', qty: 1 }
            return slots
          })(),
          held: 0,
        },
        collider: {
          ox: -4 * PIXEL_SIZE,
          oy: 15 * PIXEL_SIZE,
          w: 8 * PIXEL_SIZE,
          h: 2 * PIXEL_SIZE,
        },
        target: {
          oy: 22 * PIXEL_SIZE,
          radius: 7 * PIXEL_SIZE,
        },
      }
    },
  },
  portal: {
    name: 'portal',
    type: 'portal',
    label: 'Portal',
    icon: null,
    create({ id, x, y, chunkId = null, destX = 0, destY = 0 }) {
      return {
        id,
        name: 'portal',
        type: 'portal',
        chunkId,
        position: {
          x,
          y,
          yBase: 9 * PIXEL_SIZE,
        },
        sprite: {
          url: '/assets/portal.png',
          width: 2,
          height: 3,
          fps: 8,
        },
        shadow: {
          url: '/assets/portal.shadow.png',
        },
        trigger: {
          ox: -9 * PIXEL_SIZE,
          oy: 9 * PIXEL_SIZE,
          w: 18 * PIXEL_SIZE,
          h: 6 * PIXEL_SIZE,
        },
        dest: {
          x: destX,
          y: destY,
        },
        target: {
          oy: 9 * PIXEL_SIZE,
          radius: 10 * PIXEL_SIZE,
        },
      }
    },
  },
}

export function createEntityByName({ id, name, x, y, chunkId = null }) {
  const def = getEntityByName(name)
  return def?.create({ id, x, y, chunkId }) || null
}

export function getEntityByName(name) {
  return entities[name] || null
}
